import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

import { DayTypes, useLeaveStore } from '@/stores/leave'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarDay',
  props: {
    date: null,
    visible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    date: Date,
    visible: boolean
};




const leaveStore = useLeaveStore()

const dayTypeMom = computed(() => leaveStore.isDayOff(true, props.date))
const dayTypePartner = computed(() => leaveStore.isDayOff(false, props.date))
const isDueDate = computed(() => props.date.getDate() === leaveStore.personal.dueDate!!.getDate() && props.date.getMonth() === leaveStore.personal.dueDate!!.getMonth())


return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass({
            [_ctx.$style.day]: true,
            [_ctx.$style.dayOffMom]: (_unref(dayTypeMom) === _unref(DayTypes).ParentalLeave || _unref(dayTypeMom) === _unref(DayTypes).PartTimer) && !_unref(isDueDate),
        })
      }, [
        (_unref(isDueDate))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(_ctx.$style.dueDate)
            }, " 🥳 ", 2))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass({[_ctx.$style.weekend]: __props.date.getDay() === 6 || __props.date.getDay() === 0})
            }, _toDisplayString(__props.date.getDate()), 3)),
        ((_unref(dayTypePartner) === _unref(DayTypes).ParentalLeave || _unref(dayTypePartner) === _unref(DayTypes).PartTimer) && !_unref(isDueDate))
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass(_ctx.$style.dayOffPartner)
            }, null, 2))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})